import Vuex from 'vuex';
import Vue from "vue";
import {router} from "./main";
import * as signalR from './signalr';
import * as moment from 'moment';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    tracker: {
      id: undefined,
      contact: undefined,
      user: undefined,
    },
    findingTracker: true,
    distanceMatrix: {
      distance: {
        text: '',
      },
      duration: {
        text: '',
        value: 0,
      },
    },
    loadingDistanceMatrix: false,
    isTrackerExpired: false,
    mode: 'day',
  },
  getters: {
    tracker: state => state.tracker,
    contact: state => state.tracker.contact,
    user: state => state.tracker.user,
    findingTracker: state => state.findingTracker,
    isTrackerExpired: state => state.isTrackerExpired,
    location: state => state.tracker.contact.location,
    recentReviews: state => state.tracker.user.reviewMatches,
    colorTheme: state => state.mode,
    distanceMatrix: state => state.distanceMatrix,
    loadingDistanceMatrix: state => state.loadingDistanceMatrix,
  },
  mutations: {
    setTracker(state, tracker) {
      state.tracker = tracker;
    },
    setFindingTracker(state, finding) {
      state.findingTracker = finding;
    },
    setDistanceMatrix(state, distanceMatrix) {
      state.distanceMatrix = distanceMatrix;
    },
    setTrackerExpired(state, isTrackerExpired) {
      state.isTrackerExpired = isTrackerExpired;
    },
    setUserCoordinates(state, coordinates) {
      state.tracker.user = {
        ...state.tracker.user,
        lat: coordinates.lat,
        lng: coordinates.lng,
      };
    },
    setMode(state, mode) {
      state.mode = mode;
    },
    setLoadingDistanceMatrix(state, loading) {
      state.loadingDistanceMatrix = loading;
    },
  },
  actions: {
    setToken(store, {token}) {
      localStorage.setItem('auth_token', token);
    },
    async loadTracker({commit, dispatch}, {token}) {
      try {
        const response = await fetch(`${process.env.VUE_APP_API}/compass`, {
          credentials: 'include',
          mode: 'cors',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 401) {
          commit('setTrackerExpired', true);
          return;
        }

        const tracker = await response.json();

        if (tracker.isRevoked) {
          commit('setTrackerExpired', true);
          return;
        }

        if (moment(tracker.updatedAt).isAfter(moment('5:00pm', 'h:mma'))) {
          commit('setMode', 'night');
        }

        signalR.createConnection(token);
        signalR.start();
        signalR.onCloseConnection();
        signalR.onCoordinatesReceived();
        signalR.onRevokeTracker();
        commit('setTracker', tracker);
        commit('setFindingTracker', false);
      } catch (err) {
        dispatch('loadTrackerFail');
      }
    },
    async loadTrackerFail() {
      signalR.disconnect();
      await router.push('/error');
    },
    async getEstimatedDistance({commit, dispatch}, {origins, destinations}) {
      commit('setLoadingDistanceMatrix', true);
      const token = localStorage.getItem('auth_token');
      try {
        const response = await fetch(`${process.env.VUE_APP_API}/google/distance?origins=${origins}&destinations=${destinations}`, {
          credentials: 'include',
          mode: 'cors',
          headers: {
            Authorization: `Bearer ${token}`,
          }
        });

        if (response.status === 200) {
          const matrix = await response.json();
          commit('setDistanceMatrix', matrix);
          commit('setLoadingDistanceMatrix', false);
        }

        if (response.status === 401) {
          signalR.disconnect();
          commit('setTrackerExpired', true);
        }
      } catch (e) {
        console.log(e);
      }
    },
    setUserCoordinates({commit}, {coordinates}) {
      commit('setUserCoordinates', coordinates);
    },
    revokeTracker({commit}) {
      commit('setTrackerExpired', true);
    },
  }
});
